import deepEqual from "fast-deep-equal";

function idempotent() {
  let invocations = [];

  return function() {
    let args = {
      arguments: [...arguments]
    };
    return function(fn) {
      return function() {
        if (invocations.length > 0) {
          let existing = invocations.find(i => deepEqual(i.arguments, args));
          if (existing) {
            return existing.promise;
          }
        }
        let result = fn.apply(this, arguments);
        if (typeof result.then === "function") {
          let invocation = {
            arguments: args
          };
          let remove = () => {
            let idx = invocations.indexOf(invocation);
            if (idx >= 0) {
              invocations.splice(idx, 1);
            }
          };
          invocation.promise = Promise.resolve(result).then(
            obj => {
              remove();
              return obj;
            },
            err => {
              remove();
              throw err;
            }
          );
          result = invocation.promise;
          invocations.push(invocation);
        }
        return result;
      };
    };
  };
}

export default idempotent;
